import Location from "@/utils/collisionWarning/Location";

const zip = (array1, array2) => array1.map((_, i) => [array1[i], array2[i]]);

export const isLineCrossing = plotPoints => {
  if (plotPoints.length < 3) {
    return false;
  }
  const points = plotPoints.map(function(value) {
    const location = new Location(value[1], value[0]);
    return location.toMercatorAtlasPosition();
  });
  const nextPoint = points.slice(1, points.length).concat(points.slice(0, 1));
  const lineSegments = zip(points, nextPoint).map(function(value) {
    return { pointA: value[0], pointB: value[1] };
  });
  var result = false;
  lineSegments.forEach(segmentA => {
    const index = lineSegments.findIndex(item => item === segmentA);
    if (index < lineSegments.length - 1) {
      lineSegments.slice(index + 1, lineSegments.length).forEach(segmentB => {
        if (isCrossing(segmentA, segmentB)) {
          result = true;
          return;
        }
      });
    }
  });
  return result;
};

export const isCrossing = (segmentA, segmentB) => {
  const x1 = segmentA.pointA.x;
  const y1 = segmentA.pointA.y;
  const x2 = segmentA.pointB.x;
  const y2 = segmentA.pointB.y;
  const x3 = segmentB.pointA.x;
  const y3 = segmentB.pointA.y;
  const x4 = segmentB.pointB.x;
  const y4 = segmentB.pointB.y;

  return (
    ((x1 - x2) * (y3 - y1) + (y1 - y2) * (x1 - x3)) *
      ((x1 - x2) * (y4 - y1) + (y1 - y2) * (x1 - x4)) <
      0 &&
    ((x3 - x4) * (y1 - y3) + (y3 - y4) * (x3 - x1)) *
      ((x3 - x4) * (y2 - y3) + (y3 - y4) * (x3 - x2)) <
      0
  );
};
